import { render, staticRenderFns } from "./kv-pagination.vue?vue&type=template&id=fe261036&scoped=true"
import script from "./kv-pagination.vue?vue&type=script&lang=js"
export * from "./kv-pagination.vue?vue&type=script&lang=js"
import style0 from "./kv-pagination.vue?vue&type=style&index=0&id=fe261036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe261036",
  null
  
)

export default component.exports